<template>
  <generic-modal :title="$t('process deployment')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("version") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.version"
                :placeholder="$t('version')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('variable set')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/ngine/variable-set/catalog"
              name_field="name"
              value_field="set_id"
              @selected="set_variable_set"
              ref="variable_set_dropdown"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-rocket"></i>
        </span>
        <span>{{ $t("deploy") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      loading: false,
      process: {},
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.version;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(process) {
      let v = this;
      v.set_initial_state();
      v.process = process;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.$root.loader(true);
      let data = { ...v.meta, uuid: v.process.uuid };
      post("/ngine/composer/process/deploy", data)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.loading = false;
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.process = {};
      v.loading = false;
      v.$refs.variable_set_dropdown.clear();
      v.error = "";
    },
    set_variable_set(variable_set) {
      let v = this;
      if (variable_set) v.meta.variable_set_id = variable_set.set_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
